import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { OrganizationContract } from '@/api/rest/resources/types/organization';
import { SuspenseBoundary } from '@/components/SuspenseBoundary';

import { ContractCard } from './ContractCard';

type ContractsListProps = {
  contracts: OrganizationContract[];
  totalContracts?: number;
};

export const ContractsList = ({ contracts, totalContracts }: ContractsListProps) => {
  const { t } = useTranslation();

  return (
    <SuspenseBoundary>
      <Stack data-testid='contracts-section'>
        <Stack direction='row' className='w-full justify-between'>
          <span className='typography-body2 font-medium text-text-primary uppercase'>
            {t('contracts.count', { count: totalContracts })}
          </span>
        </Stack>
        <Stack direction='row' spacing={6} className='flex-wrap w-full py-5'>
          {contracts.map((contract) => (
            <div key={contract.id}>
              <ContractCard contract={contract} />
            </div>
          ))}
        </Stack>
      </Stack>
    </SuspenseBoundary>
  );
};
